import { importJSON } from "../../lib/importJSON";
import { lddGlobalSessionInfo, ProvincesShortCode } from "../navigationTypes";
import { LenderContactType, MortgageLenderItem, } from "./MortgageLenderTypes";
import { runInnerFunction } from "../../compatManager";
import { DischargeListItem } from "./DischargeLenderLink";
import './mortgageLender.css';

export function getBranchData(
    LDDLenderID: number,
    sessionInfo: lddGlobalSessionInfo,
    setData: (value: LenderContactType[]) => void,
    lenderData: MortgageLenderItem,
    setShowBranch: (value: boolean) => void,
    refresh: boolean
) {
    if (lenderData.branches.length < 1 || refresh) {
        let initBranch: LenderContactType = {
            LenderContactID: 0,
            LDDLenderID: 0,
            LenderID: 0,
            LawyerID: "",
            Branch: "",
            TransitNum: 0,
            XMLData: "",
            SortOrder: "",
            isDischarge: "",
            isDefault: "",
            LenderProgramID: "",
            isBranch: true,
            LenderName: "",
        }
        const data = fetchDataLender(sessionInfo.firm.id, sessionInfo.appProvinceShort, sessionInfo.sid, 1, '', 'sub_lenders', LDDLenderID);
        if (data.length === 1) {
            data[0]?.then(
                response => {
                    response.json().then(
                        data => {
                            const newBranches: LenderContactType[] = data.result.map((subBranch) => importJSON(subBranch, initBranch));
                            setData(newBranches);
                            setShowBranch(true);
                        }
                    )
                }
            )
        }
    }
}

export function fetchDataLender(
    firmId: number,
    prov: ProvincesShortCode,
    sid: string,
    filePage: number,
    searchText: string,
    searchType: string,
    LDDLenderID: number,
): Promise<Response>[] {
    try {
        if (firmId && sid) {
            const body = {
                page: filePage,
                searchType: searchType,
                search: searchText,
                multiPredicate: [LDDLenderID, 1]
            }
            const responseData = fetch(`/${process.env.REACT_APP_RWAPI_ENDPOINT}/api/${prov}/${firmId}/get/list?SessionID=${sid}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            })
            const responsePromises = [responseData];
            return responsePromises;
        }
        return [];
    } catch (e) {
        console.log(e);
        return [];
    }
}

export function selectBranchLink(mainBranch: MortgageLenderItem | DischargeListItem, SubBranch?: LenderContactType) {
    if (SubBranch) {
        mainBranch.selectBranch = SubBranch;
    } else {
        mainBranch.selectBranch = null;
    }
    let returnVal = runInnerFunction('ReactShell.reactSelectMortgage', mainBranch);
    if (!returnVal) {
        alert('Main branch of this lender is not available. Please select from the existing branches or click "+Branch" to add a new branch.');
        return false;
    }
    return true;
}